import $ from 'jquery';

export default function screensSection() {
	const $html = $('html');
	const $window = $(window);
	const $scroller = $('html, body');

	$('.body_screens:not(.no-scroll)').each(function() {
		const $container = $(this);
		let swipeIndex;
		$window.on('scroll resize load', (e) => {
			const winWidth = $window.width();
			const winHeight = $window.height();
			const containerRect = $container[0].getBoundingClientRect();
			const $screens = $container.children();
			const numScreens = $screens.length;

			// If we're inside the mobl breakpoint clean up everything and
			// return early
			if (winWidth < 640) {
				$container.removeClass('fixed approachingFromTop');
				$screens.find('.screen_media').attr('css', '');
				return;
			}

			const offset = (winHeight - $screens.first()[0].getBoundingClientRect().height) / 2

			const $last = $screens.last();
			const atBottom = (
				($last[0].getBoundingClientRect().top - offset) < 0
				// ((winHeight - $last.find('.screen_media img')[0].getBoundingClientRect().height) / 2)
			)

			const atTop = containerRect.top - offset < 0

			if (!atTop) {
				$container.addClass('approachingFromTop');
			} else {
				$container.removeClass('approachingFromTop');
			}

			if (atBottom) {
				$container.addClass('approachingFromBottom');
			} else {
				$container.removeClass('approachingFromBottom');
			}

			if (atTop && !atBottom) {
				$container.addClass('fixed');

				$screens.each(function(index) {
					const $screen = $(this);
					const rect = $screen[0].getBoundingClientRect();
					const $img = $screen.find('.screen_media');
					let height = rect.height - (0 - rect.top)
					height = scaleClamp(
						offset,
						rect.top - offset,
						rect.bottom + offset,
						100,
						0
					)
					$img.css('height', height + '%');
					$img.css('z-index', 100 - index);
				});
				return
			} else if (atBottom) {
				const $img = $last.find('.screen_media')

				$img.css('height', '');
				$img.css('z-index', '');
			}

			$container.removeClass('fixed');
		});
	});
};

const scale = (i, a, b, x, y) => ((i - a) / (b - a)) * (y - x) + x;
const scaleClamp = (i, a, b, x, y) => (
	x > y ?
	Math.max(y, Math.min(x, scale(i, a, b, x, y))) :
	Math.max(x, Math.min(y, scale(i, a, b, x, y)))
);



// WEBPACK FOOTER //
// ./source/scripts/sections/screens.js